import { useLayoutEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"

import CloseableSnackbar, {
  useCloseableSnackbarState,
} from "../../../common/components/CloseableSnackbar"
import Column from "../../../common/components/Column"
import { isConcierge } from "../../users/accountRole"
import { selectProfile } from "../../users/reducer"
import { retrieveCRMSettings } from "../reducer"
import AmdSettingsCard from "./AmdSettingsCard"
import ConciergeBuyCallingNumberCard from "./ConciergeBuyCallingNumberCard"
import PhoneConnectionSettingsCard from "./PhoneConnectionSettingsCard"
import ProfileColumn from "./ProfileColumn"
import SmsConnectionSettingsCard from "./SmsConnectionSettingsCard"

export default function PhoneSmsConnectionTab() {
  const dispatch = useDispatch()
  const profile = useSelector(selectProfile)
  const concierge = isConcierge(profile)
  const [searchParams] = useSearchParams()
  const phoneSectionRef = useRef(null)
  const smsSectionRef = useRef(null)
  const greetingSectionRef = useRef(null)
  const amdSectionRef = useRef(null)
  const {
    isOpen: snackbarOpen,
    message: snackbarMessage,
    severity: snackbarSeverity,
    open: openSnackbar,
    close: closeSnackbar,
  } = useCloseableSnackbarState()

  // Detection settings live on the parent account's CRM settings, so they are
  // needed for concierges as well now that they get the card.
  useLayoutEffect(() => {
    dispatch(retrieveCRMSettings())
  }, [dispatch])

  useLayoutEffect(() => {
    const focus = searchParams.get("focus")
    const map = concierge
      ? { greeting: greetingSectionRef, amd: amdSectionRef }
      : {
          phone: phoneSectionRef,
          sms: smsSectionRef,
        }
    const ref = map[focus]
    ref?.current?.scrollIntoView({ behavior: "smooth", block: "start" })
  }, [searchParams, concierge])

  return (
    <ProfileColumn sx={{ gap: 3 }}>
      <Column sx={{ gap: 3, width: "100%" }}>
        {concierge ? (
          <>
            <div ref={greetingSectionRef}>
              <ConciergeBuyCallingNumberCard onStatusMessage={openSnackbar} />
            </div>
            {/* Detection is an operator setting: concierges run the dialer,
                so it is theirs to tune on whichever parent account they are
                working. Account owners do not see it. */}
            <AmdSettingsCard
              ref={amdSectionRef}
              onStatusMessage={openSnackbar}
            />
          </>
        ) : (
          <>
            <PhoneConnectionSettingsCard
              ref={phoneSectionRef}
              onStatusMessage={openSnackbar}
            />
            <SmsConnectionSettingsCard
              ref={smsSectionRef}
              onStatusMessage={openSnackbar}
            />
          </>
        )}
      </Column>
      <CloseableSnackbar
        open={snackbarOpen}
        onClose={closeSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </ProfileColumn>
  )
}
